export const GLOBAL_NAV_SEARCH_INPUT_FIELD_ID = 'GlobalNavSearchInputField';
